import axios from '@/api';
import { langSuffix } from '@/api/statute';

export function registerMailContentField(lang) {
    return `registerMailContent${langSuffix(lang)}`;
}

export function htmlBreaksToNewlines(value) {
    if (value == null) {
        return '';
    }
    return String(value)
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n');
}

export function newlinesToHtmlBreaks(value) {
    if (value == null) {
        return '';
    }
    return String(value)
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .replace(/\n/g, '<br />');
}

export function updateRegisterMailContent(competitionId, lang, value) {
    return axios.put(`panel/competitions/${competitionId}`, {
        [registerMailContentField(lang)]: value,
    });
}

export function sendTestRegister(competitionId, information) {
    return axios.post(`/send-test-register/${competitionId}`, { information });
}
